import { BaseApi, Environment } from '@nextroll/ar-base-api';

const authApi = new BaseApi('/rofl-api/v1/authentications', {
    environment: (process.env.ENVIRONMENT || 'development') as Environment,
});

/**
 * Get the list of existing authentications for a given Advertisable.
 * @param advertisableEid  The user's associated advertisable EID.
*/
export const getAuthenticationList = async (advertisableEid: string) => {
    const response = await authApi.get('', { advertisable_eid: advertisableEid });
    return response?.result || [];
};
